import { useEffect } from 'react';

const useFullscreen = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
};

export default useFullscreen;
